(function () {
  angular.module('binky.core.api.interceptor', [
    'binky.core.authentication',
    'binky.core.src2-migration',
  ]);
})();
